export const OrderType = {
  B2C: "B2C",
  B2B: "B2B",
  PARTNER: "Partner",
  DELHI_TENDOR: "Delhi Tender",
};
export const PO_STATUS = {
  confirmed: "Confirmed",
  closed: "Closed",
  open: "Open",
  pending: "Pending",
  rejected: "Rejected",
};
export const OrderTypeLabel = ["", "B2C", "B2B", "PARTNER", "DELHI TENDER"];
export const OrderStatus = {
  INIT: "Initialized",
  CONFIRMED: "Confirmed",
  WANT_TO_CANCEL: "Want to cancel",
  CANCELLED: "Cancelled",
  DISPATCHED: "Dispatched",
  PARTIAL_DELIVERED: "Partial Delivered",
  DELIVERED: "Delivered",
  INSTALLED: "Installed",
  REFUNDED: "Refunded",
  hold: "On Hold",
  config_pending: "Configuration pending",
  write_off: "Write Off",
};
export const OrderStatusLabel = [
  "",
  "Initialized",
  "Confirmed",
  "Want to cancel",
  "Cancelled",
  "Dispatched",
  "Partial Delivered",
  "Delivered",
  "Installed",
  "Refunded",
];
export const PaymentStatus = {
  PENDING_PAYMENT: "Pending Payment",
  ADVANCE_PAYMENT: "Partial Paid",
  FULL_PAYMENT: "Full Paid",
};
export const DiscountType = { COUPON: "Coupon", DIRECT: "Direct" };
export const CouponType = {
  GENERIC: "Generic",
  SPECIFIC: "Specific",
  REFERER: "Referer",
};
export const DiscountValueType = { AMOUNT: "Amount", PERCENT: "Percent" };
// export const CouponValueTypeLabel = ["", "AMOUNT", "PERCENT"];
export const ProductType = { CHARGING_STATION: 0 };
export const TransactionType = {
  REFUND: "Refund",
  PAYMENT: "Payment",
  // BALANCE: "Balance",
};
export const AddressType = { HOME: "Home", OFFICE: "Office", OTHER: "Other" };
// export const AddressTypeLabel = ["", "Home", "Office", "Other"];
export const HostType = { USER: 0, DEALER: 1, DISTRIBUTOR: 2 };
export const OrderItemStatus = {};
export const TransactionStatus = {
  PENDING: "Pending",
  SUCCESS: "Success",
  FAILED: "Failed",
};
export const TransactionStatusLabe = ["", "Pending", "Success", "Failed"];
// exports={OrderType,CouponType,DiscountType,TransactionType,ProductType,OrderStatus,TransactionStatus}
export const MODULE = {
  access_panel: "Access panel",
  user: "User",
  emp: "Emp",
  role: "Role",
  order_panel: "Order panel",
  order: "Order",
  all_order: "All order",
  order_comment: "Order comment",
  order_customer_mail: "Order customer mail",
  order_view: "Order View",
  order_approve: "Order approve",
  modify_cart: "Modify cart",

  content_panel: "Content panel",
  content: "Content",
  invoice: "Invoice",

  export_data: "Export data",
  order_export_90_days: "Order export 90 days",
  order_export_all: "Order export all",
  analytic: "Analytic",

  website_order_mail: "Website order mail",
  ops_weekly_mail: "weekly ops mail",
  finance_weekly_mail: "Weekly finance mail",
  admin_weekly_mail: "Weekly admin mail",
  complaint_admin_mail: "Complaint admin mail",

  complaint_panel: "Complaint panel",
  complaint: "Complaint",
  all_compaint: "All complaint",

  customer_panel: "Customer panel",

  device_inventory_panel: "Device inventory panel",
  raw_inventory_panel: "Raw inventory panel",

  ops_task_panel: "Ops task panel",
  ops_ticket: "Ops ticket",
  ops_task: "Ops task",

  api_inegration_panel: "Api panel",
  api: "Api",
  api_master: "Api master",

  hrm_panel: "HRM panel",
  hrm_employee: "HRM employee",
  hrm_leave: "HRM leave",
  master_data_panel: "Master data panel",
  safety_check: "Safety check",
  academy: "academy",
  // cost_center_maker: "Cost Center maker",
  // cost_center_checker: "Cost Center checker",
  procurement_panel: "Procurement_panel",

  dashboard: "Dashboard",
  purchase_order: "Purchase order",
  purchase_order_self: "Purchase order self",
  purchase_order_approval: "Purchase order approval",
  purchase_order_approval_L1: "Purchase order approval L1",
  purchase_order_approval_L2: "Purchase order approval L2",
  purchase_order_approval_L3: "Purchase order approval L3",
  master_item_maker: "Master Item Maker",
  master_item_checker: "Master Item Checker",
  payment_request_maker: "Payment Request Maker",
  payment_request_checker: "Payment Request Checker",
  payment_request_approval: "Payment Request Approval",

  master_vendor_checker: "Master Vendor Checker",
  master_vendor_maker: "Master Vendor Maker",

  material_planning_uploader: "Material Planning Uploader",
  material_panning_viewer: "Material Planning Viewer",

  cost_center: "Cost Center",
  cost_center_approval_L1: "Cost center approval L1",
  cost_center_approval_L2: "Cost center approval L2",

  project_master: "Project Master",
  project_master_maker: "Project Master Maker",
  transform_item: "Transform Item",
  transform_item_approval: "Transform Item Approval",
  warehouse: "Warehouse",

  voucher: "vouchers",
  voucher_self: "vouchers self",
  procurement_master: "procurement master",
  procurement_read_only: "procurement_read_only",
  po_amender: "po_amender",
  update_partial_po: "Update Partial POs",
  po_bulk_import: "po bulk import",
  customer_master: "customer_master",
  customer_approval: "customer_approval",
  inventory_journals: "inventory journals",
  inventory_journal_self: "inventory journal self",
  stock_transfer_journals: "stock transfer journals",
  stock_outward: "Stock Outward",
  // stock_outward_approval: "Stock Outward Approval",
  vendors: "Vendors",
  NPD: "NPD",
  "PT-Tool Admin": "PT-Tool Admin",
  SOP: "SOP",
  case_study: "Case Study",
  access_guide: "Access Guide",
  user_role: "User Role",
  knowledge_management: "Knowledge Management",
  warehouse_operator: "Warehouse Operator",
  grn_permission: "GRN Permission",
  warehouse_manager: "Warehouse Manager",
  warehouse_panel: "Warehouse Panel",
  warehouse_module_inward: "Warehouse Module Inward",
  warehouse_module_outward: "Warehouse Module Outward",
  warehouse_module_stock_transfers: "Warehouse Module Stock Transfers",
  warehouse_module_finance: "Warehouse Module Finance",
  warehouse_module_team_management: "Warehouse Module Team",
  warehouse_stock_ledger: "Warehouse Stock Ledger",
  warehouse_quarantine_dashboard: "Warehouse Quarantine Dashboard",
  warehouse_inventory_dashboard: "Warehouse Inventory Dashboard",
  warehouse_module_view_only: "Warehouse Module View Only",
  warehouse_revert_order: "Warehouse Revert Order",
  audit_stock_upload: "Audit Stock Upload",
  faulty_device_resolution: "Faulty Device Resolution",
  kazam_gst: "Kazam GST",
  request_desk_panel: "Request Desk panel",
  request_desk: "Request Desk",
  request_desk_all: "Request Desk all requests",
  request_desk_sr_approval: "Request Desk SR approval",
  request_desk_triage: "Request Desk triage",
  request_desk_execute: "Request Desk execute",
  request_desk_fault_dashboard: "Request Desk fault dashboard",
  stock_audit_lockdown_bypass: "Stock Audit Lockdown Bypass",
  replacement_request_approval: "Replacement Request Approval",
  replacement_st_hw_approval: "Replacement ST HW Approval",
  replacement_st_biz_approval: "Replacement ST Business Approval",
  
  omnichannel: "OmniChannel",
  omnichannel_calls: "OmniChannel Calls",
};
export const MODULE1 = {
  USER: 1,
  ROLE: 2,
  ORDER: 3,
  CONTENT: 4,
  PAYMENT: 5,
  COMMENT: 6,
  COMMUNICATION: 7,
  INVOICE: 8,
  EXPORTDATA: 9,
  MODIFYCART: 10,
  ANALYTICS: 11,
  TNX_AC_MAIL: 12,
  TNX_OP_MAIL: 13,
  TNX_ADMIN_MAIL: 14,
  COMPLAINT: 15,
  CUSTOMER: 16,
  SALES_FORCE: 17,
  INVENTORY: 18,
  INSTALLED_DEVICES: 19,
  HOST: 20,
  DEVICES: 21,
  OPS_PANEL: 22,
  CONTENT_PANEL: 23,
  API_KEY: 24,
  ALL_ORDERS: 25,
  ORDER_PANEL: 26,
  TXN_PANEL: 27,
  INVENTORY_PANEL: 28,
  HRM_PANEL: 29,
  SALES_FORCE_PANEL: 30,
  ACCESS_PANEL: 31,
  OPS_TICKET: 32,
  OPS_BASKET: 33,
  OPS_TASK: 34,
  COMPLAINT_PANEL: 35,
  HR_OVERVIEW: 36,
  HR_EMPLOYEES: 37,
  HR_EMP_LEAVE: 38,
  MASTER_DATA: 39,
  ALL_COMPLAINTS: 40,
  ALL_OPS_TICKETS: 41,
  INSTALLATION_SAFTY_CHECK: 42,
  MEDIA_FILE: 43,
  COMPLAINT_ADMIN_MAIL: 44,
  ACADEMY: 45,
};
export const MODULELABEL = [
  "",
  "Users",
  "Roles",
  "Orders",
  "Content",
  "Payment",
  "Comment",
  "Communication",
  "Invoice",
  "Export data",
  "Modify cart",
  "Analytics",
  "Tnx AC mail",
  "Tnx ops mail",
  "Tnx admin mail",
  "Complaint",
  "Customer",
  "Sales force",
  "Inventory",
  "Installed Devices",
  "Hosts",
  "Devices",
  "Ops panel",
  "Content panel",
  "API key",
  "All Order",
  "Order Panel",
  "Txn Panel",
  "Inventory Panel",
  "HRM Panel",
  "Sales Force Panel",
  "Access Panel",
  "Ops Tickets",
  "Ops Basket",
  "Ops Task",
  "Complaint Panel",
  "HR OVERVIEW",
  "HR EMPLOYEES",
  "HR EMP LEAVE",
  "Master Data",
  "All Complaints",
  "All Ops Tickets",
  "Insallation/Safty check",
  "Media Files",
  "Complaint Admin Mail",
  "Academy",
];
export const ACTION = {
  READ: "Read",
  CREATE: "Create",
  UPDATE: "Update",
  DELETE: "Delete",
  ALL: "All",
};
export const ACTION1 = {
  CREATE: 1,
  READ: 2,
  UPDATE: 3,
  DELETE: 4,
  ALL: 5,
};

export const ACTIONLABEL = ["", "Create", "Read", "Update", "Delete", "All"];
export const OrderCreateStates = {
  LOADING: 0,
  LOADED: 1,
  ERROR: 2,
};
export const OrderCreatePages = {
  ADDITEMPAGE: 0,
  CUSTOMERDETAILPAGE: 1,
};

export const PaymentRefType = {
  order: "order",
  subscription: "subscription",
};
export const PaymentMode = {
  Cash: "Cash",
  cheque: "Cheque",
  debit_card: "Debit Card",
  credit_card: "Credit Card",
  upi: "UPI",
  netbanking: "Net Banking",
};
export const PaymentModeLabe = [
  "",
  "Cash",
  "Cheque",
  "Debit Card",
  "Credit card",
  "UPI",
];

export const SubDepartments: { [key: string]: string[] } = {
  Strategy: ["Strategy Member"],
  "Supply Chain": [
    "Production",
    "Procurement",
    "Procurement & Logistics",
    "Manufacturing",
    "Supply Chain",
    "Warehouse",
    "Project Management",
  ],
  Hardware: ["Firmware", "Hardware"],
  "Data Science": ["Data Science"],
  Quality: ["Quality"],
  "Quality and Safety": ["Quality"],
  Sales: [
    "RWA & Builder",
    "Community Charging",
    "Bus Segment",
    "Integration/SAAS",
    "Sales Member",
    "RWA",
    "Sales",
    "Home Solutions",
    "Inside sales",
    "Community Solution",
    "Fleet",
    "Enterprise",
    "Community Solutions: RWA & Office",
    "SaaS Sales",
  ],
  Project_Delivery: ["Project Delivery"],
  Marketing: ["Content/Graphic Design", "Marketing", "Content/GD"],
  "New Initiatives": ["New Initiatives"],
  Finance: ["Finance", "Company Secretary", "Finance Member"],
  "Founder's Office": ["Founder's Office"],
  Procurement: ["Procurement Member"],
  Design: [
    "Graphic Design",
    "Industrial Design",
    "UI/UX",
    "Design Member",
    "Mechanical Design",
  ],
  "Human Resources": ["Human Resources"],
  Operations: [
    "Operations Member",
    "Home Installation",
    "Testing & Calibration",
    "Public Charging",
    "Operations",
    "Installation Engineer",
    "Community Charging",
  ],
  HR: ["HR Member"],
  "Customer Success": [
    "Support Member",
    "Customer Support",
    "Project Delivery",
  ],
  Content: ["Content Member"],
  "Electric R&D & Safety": ["Electric R&D & Safety"],
  Product: ["Product Manager", "Tech Member"],
  Management: ["Management"],
  Tech: ["Mobile App", "Back End", "Tech Member"],
  Technology: ["Firmware Tech", "Software Tech", "Hardware Tech"],
  "Firmware Tech": ["Firmware Tech"],
  "Hardware Tech": ["Hardware Tech"],
};

export const Departments = {
  Product: "Product",
  "Electric R&D & Safety": "Electric R&D & Safety",
  "Customer Success": "Customer Success",
  Content: "Content",
  Technology: "Technology",
  Strategy: "Strategy",
  Management: "Management",
  Tech: "Tech",
  "Project Delivery": "Project Delivery",
  Design: "Design",
  Procurement: "Procurement",
  "Human Resources": "Human Resources",
  Operations: "Operations",
  HR: "HR",
  Marketing: "Marketing",
  "Founder's Office": "Founder's Office",
  Finance: "Finance",
  "New Initiatives": "New Initiatives",
  "Data Science": "Data Science",
  "Supply Chain": "Supply Chain",
  Hardware: "Hardware",
  Quality: "Quality",
  Sales: "Sales",
  "Quality and Safety": "Quality and Safety",
};

export const SubDeptLogoMap: { [key: string]: string } = {
  /* ===================== Strategy ===================== */
  Strategy: "strategy",
  "Strategy Member": "strategy",

  /* ===================== Supply Chain ===================== */
  "Supply Chain": "supply_chain",
  Production: "manufacturing",
  Procurement: "procurement",
  "Procurement & Logistics": "procurement",
  Manufacturing: "manufacturing",
  Warehouse: "warehouse",
  "Project Management": "project",

  /* ===================== Hardware ===================== */
  Hardware: "hardware",
  Firmware: "firmware",

  /* ===================== Data Science ===================== */
  "Data Science": "datascience",

  /* ===================== Quality ===================== */
  Quality: "quality",

  /* ===================== Quality and Safety ===================== */
  "Quality and Safety": "quality",

  /* ===================== Sales ===================== */
  Sales: "sales",
  "Sales Member": "sales",
  RWA: "community",
  "RWA & Builder": "community",
  "Community Charging": "community_charging",
  "Community Solution": "community",
  "Community Solutions: RWA & Office": "community",
  "Community Solutions: e-commerce": "ecommerce",
  "Community Solutions: bus": "bus",
  "Bus Segment": "bus",
  "Integration/SAAS": "saas",
  "SaaS Sales": "saas",
  "Home Solutions": "home",
  "Inside sales": "sales",
  Fleet: "fleet",
  Enterprise: "enterprise",
  "Public Solutions": "public",

  /* ===================== Project Delivery ===================== */
  "Project Delivery": "project",

  /* ===================== Marketing ===================== */
  Marketing: "marketing",
  "Content/Graphic Design": "content",
  "Content/GD": "content",

  /* ===================== New Initiatives ===================== */
  "New Initiatives": "strategy",

  /* ===================== Finance ===================== */
  Finance: "finance",
  "Finance Member": "finance",
  "Company Secretary": "finance",

  /* ===================== Founder's Office ===================== */
  "Founder's Office": "management1",

  /* ===================== Procurement ===================== */
  "Procurement Member": "procurement",

  /* ===================== Design ===================== */
  Design: "design",
  "Graphic Design": "design",
  "Industrial Design": "industrial",
  "UI/UX": "uiux",
  "Design Member": "design",
  "Mechanical Design": "mechanical",

  /* ===================== Human Resources ===================== */
  "Human Resources": "hr",
  HR: "hr",
  "HR Member": "hr",

  /* ===================== Operations ===================== */
  Operations: "operations",
  "Operations Member": "operations",
  "Home Installation": "home_installation",
  "Testing & Calibration": "testing",
  "Public Charging": "public_charging",
  "Installation Engineer": "installation",

  /* ===================== Customer Success ===================== */
  "Customer Success": "support",
  "Support Member": "support",
  "Customer Support": "support",

  /* ===================== Content ===================== */
  Content: "content",
  "Content Member": "content",

  /* ===================== Electric R&D & Safety ===================== */
  "Electric R&D & Safety": "rnd",

  /* ===================== Product ===================== */
  Product: "product",
  "Product Manager": "product",
  "Tech Member": "tech",

  /* ===================== Management ===================== */
  Management: "management1",

  /* ===================== Tech ===================== */
  Tech: "tech",
  "Mobile App": "mobile",
  "Back End": "backend",

  /* ===================== Technology ===================== */
  Technology: "technology",
  "Software Tech": "software_tech",
  "Hardware Tech": "hardware",
  "Firmware Tech": "firmware",
};

export const FileType = {
  UNKOWN: "Unkown",
  IMAGE: "Image",
  VIDEO: "Video",
  PDF: "PDF",
  CSV: "CSV",
};

export type AttachmentLimit = {
  /** Cap on what is actually uploaded — for video, the compressed size. */
  max_size_mb: number;
  max_count?: number;
  /**
   * Cap on the raw file the user picks, before compression. Only videos have
   * one: they are compressed in the browser first, so the upload cap is checked
   * against the compressed result, not the original.
   */
  max_input_size_mb?: number;
};

// Kept in sync with kazam-backend src/infrastructure/utils/enums.ts ATTACHMENT_LIMITS.
export const ATTACHMENT_LIMITS: Record<
  "image" | "video" | "audio" | "doc",
  AttachmentLimit
> = {
  image: { max_size_mb: 10, max_count: 5 },
  video: { max_size_mb: 30, max_count: 2, max_input_size_mb: 100 },
  audio: { max_size_mb: 20 },
  doc: { max_size_mb: 10, max_count: 3 },
};

// Audio is accepted by the API but never offered in the complaint UI, so it is
// left out of the caps the complaint drop zones advertise and enforce.
export const COMPLAINT_ATTACHMENT_LIMITS = {
  image: ATTACHMENT_LIMITS.image,
  video: ATTACHMENT_LIMITS.video,
  doc: ATTACHMENT_LIMITS.doc,
};

export const COMPLAINT_ATTACHMENT_ACCEPT = "image/*,video/*,application/pdf";

// Everything in one multipart request must stay well inside the proxy body cap.
export const COMPLAINT_ATTACHMENT_TOTAL_MB = 30;

export const checkList = {
  b2b: {
    brochureSent: 1,
    aggreementSigned: 2,
    deviceTraning: 3,
  },
  b2c: {
    mail: 4,
    whatsapp: 5,
    call: 6,
    deviceTraning: 7,
  },
};
export const checkListLabel = [
  "",
  "Brochures sent",
  "Aggreement signed",
  "Device traning",
  "Welcome mail",
  "Welcome whatsapp",
  "Welcome call",
  "Device traning",
];
export const checkListName = [
  "",
  "brochure",
  "aggreement",
  "traning",
  "mail",
  "whatsapp",
  "call",
  "traning",
];
export const LeadSource = [
  "Facebook",
  "Google",
  "Website",
  "Self",
  "Outbound",
  "Support phone",
  "Indiamart",
  "Amazon",
  "Flipkart",
  "Other",
];
export const sale_type = ["Free of cost", "Sale"];

export const remarks = [
  "wants to cancel",
  "Recent order",
  "Ready to pay",
  "Spot not finalized",
  "Ringing",
  "Call Back",
  "Not Reachable",
  "Awaiting LEV AC & ARAI Certification",
  "Agreement Pending",
  "Fund Issue",
  "Site under construction/Wiring pending",
  "Channel partner need to find end customer",
  "Awaiting Mini with Sim",
  "Awaiting Mini with BLE",
  "Apartment not giving permission to install",
];
export const orderCategories = [
  "Home",
  "School/College/Institute",
  "Society/Apartment",
  "Fleet",
  "Shop/Mall/Restaurant/Showroom",
  "High way/Petrol pump",
  "Office/Work place",
  "Other",
];
export const orderSegment = [
  "OEM",
  "Retail Chain",
  "Dealer",
  "Battery Swapping",
  "E-Rickshaw",
  "RWA",
  "Fleet",
  "CPO",
  "Enterprise",
  "Inside Sales",
  "Operations",
  "Online/E-commerce",
  "Other",
];

// export const complaintStatus = {
//   pending: "Pending",
//   under_progress: "Under Progress",
//   solved: "Solved",
//   cancelled: "Cancelled",
//   noted_for_future: "Noted for future",
//   Self: "Self",
// };

export const complaintStatus = {
  open: "Open",
  assigned_to_operations: "Assigned to Operations",
  service_in_progress: "Service in Progress",
  resolved: "Resolved",
  closed: "Closed",
};

export const homeInstallationComplaintStatus = {
  pending: "Pending",
  under_progress: "Under Progress",
  open: "Open",
  service_in_progress: "Service in Progress",
  assigned_to_operations: "Assigned to Operations",
  // solved: "Solved", // Removed — only Resolved status is used
  resolved: "Resolved",
  cancelled: "Cancelled",
  noted_for_future: "Noted for future",
  self: "Self",
  closed: "Closed",
};

export const DEALER_SERVICE_RELATED_TO_OPTIONS: {
  label: string;
  value: string;
}[] = [
  { label: "Socket Broken / Burnt", value: "socket_broken_burnt" },
  { label: "No Power Output", value: "no_power_output" },
  { label: "Slow Charging", value: "slow_charging" },
  { label: "MCB Tripping", value: "mcb_tripping" },
  { label: "RCCB / RCD Fault", value: "rccb_rcd_fault" },
  { label: "PCB Burnt", value: "pcb_burnt" },
  { label: "Relay Malfunctioning", value: "relay_malfunctioning" },
  { label: "LED Malfunctioning", value: "led_malfunctioning" },
  { label: "Push Button Malfunction", value: "push_button_malfunction" },
  { label: "MCU / Microcontroller Issue", value: "mcu_microcontroller_issue" },
  { label: "SMPS Faulty", value: "smps_faulty" },
  { label: "Emergency Button Issue", value: "emergency_button_issue" },
  { label: "Faulty Charging Indicators", value: "faulty_charging_indicators" },
  {
    label: "Vehicle not charging (power in device)",
    value: "vehicle_not_charging_power_in_device",
  },
  { label: "Earth Fault Issue", value: "earth_fault_issue" },
  { label: "Under Voltage / Over Voltage", value: "under_over_voltage" },
  { label: "Surge Issue", value: "surge_issue" },
  { label: "Loose Connection in DB", value: "loose_connection_db" },
  { label: "MCB Tripping (Infrastructure)", value: "mcb_tripping_infra" },
  {
    label: "Wire Loose Connection in Device",
    value: "wire_loose_connection_device",
  },
  { label: "Electric Shock", value: "electric_shock" },
  { label: "Sparks Observed", value: "sparks_observed" },
  { label: "Burning Smell", value: "burning_smell" },
  { label: "PCB Burnt (Safety)", value: "pcb_burnt_safety" },
  { label: "Earth Pit Issue", value: "earth_pit_issue" },
  { label: "Loose Connection in Wiring", value: "loose_connection_wiring" },
  { label: "Unsafe Installation", value: "unsafe_installation" },
  { label: "Fitment Issue (Wall / Pole)", value: "fitment_issue_wall_pole" },
  { label: "OTA Update Issue", value: "ota_update_issue" },
  { label: "Configuration Mismatch", value: "configuration_mismatch" },
  { label: "Delivery Tracking", value: "delivery_tracking" },
  { label: "Installation Scheduling", value: "installation_scheduling" },
  { label: "Wrong Firmware Version", value: "wrong_firmware_version" },
  { label: "Software Fault / Bug", value: "software_fault_bug" },
  {
    label: "Production Firmware Missing",
    value: "production_firmware_missing",
  },
];

export const PriorityType = {
  low: "Low",
  medium: "Medium",
  high: "High",
};
export const complaint_by = [
  "Dealers host",
  "EV Driver",
  "Host",
  "Internal Team",
  "Key Account-CMS",
  "Key Account-EV OEM",
  "Key Account-charging-station OEM",
  "Other",
];

export const ComplaintTicketType = {
  incident: "Incident",
  service_request: "Service Request",
  dev_requests: "Dev Requests",
  umbrella_incidents: "Umbrella Incidents",
  help_desk: "Help Desk",
  quality_checks: "Quality Checks",
  learning_actions: "Learning Actions",
};

export const HomeInstallTicketType = {
  incident: "incident",
  service: "service",
};

export const SourceType = {
  email: "Email",
  whatsapp: "WhatsApp",
  call: "Call",
  home: "Home",
};
export const OpsOperation = {
  delivery: "Delivery",
  installation: "Installation",
  courier: "Courier",
};
export const OpsTicketStatus = {
  pending: "Pending",
  picked: "Picked",
  completed: "Completed",
  returned: "Returned",
  missing: "Missing",
  defect: "Defect",
  cancel: "Cancel",
};

export const OpsBasketStatus = {
  active: "Active",
  deactive: "Deactive",
};
export const InventoryStatus = {
  stocked: "Stocked",
  stockOut: "Stocked Out",
  installed: "Installed",
  delivered: "Delivered",
  defect: "Defect",
  missing: "Missing",
  alloted: "Alloted",
  returnedNStocked: "Returned and Stocked",
};

export const LeaveType = {
  paid_leave: "Earned Leave",
  medicle_leave: "Medical Leave",
  restricted_holiday: "Restricted Holiday",
  work_from_home: "Work From Home",
  unpaid_leave: "Unpaid Leave",
};

export const EmpType = {
  Fulltime: "Fulltime",
  Intern: "Intern",
};

export const LeaveTypeIntern = {
  medicle_leave: "Medical Leave",
  paid_leave: "Earned Leave",
  restricted_holiday: "Restricted Holiday",
  work_from_home: "Work From Home",
  unpaid_leave: "Unpaid Leave",
};

export const LeavePeriod = {
  full_day: "Full Day",
  first_half: "First Half",
  second_half: "Second Half",
};

export const LeaveRequestStatus = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  cancelled: "Cancelled",
};

export const EmpDocCategory = {
  gmc: "GMC",
  pf: "PF",
  personal: "Personal",
};
export const EmpDocType = {
  aadhaar_card: "Aadhaar Card",
  pan_card: "Pan Card",
  bank_details: "Bank Details",
  // driving_licence: "Driving Licence",
  education: "Education",
  passport: "Passport",
  // resignation: "Resignation letter",
  // salary_slip: "Salary slips",
  signed_off: "Signed off letter",
  // experience: "Experience letter",
  // gmc_policy: "Policy",
  // gmc_claim: "Claim Process",
  gmc_card: "E-Card",
  // pf_form: "Form",
  // pf_pan: "Pan",
  // pf_aadhar: "Aadhar",
  // pf_bank_details: "Bank Details",
  // pf_epf: "EPF",
  // pf_passport: "Passport",
};

export const EmpDocStatus = {
  pending: "Pending",
  verified: "Verified",
  rejected: "Rejected",
};

// dummy line manager
export const LineManager = [
  "Swapnajit Banerjee",
  "Vignesh Gowtham",
  "Vaibhav Dagar",
];
// dummy hod
export const Hod = ["Vaibhav Tyagi", "Akshay Shekhar", "Paras"];

// HRM Weekdays
export const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// demo zones
export const zones = {
  north: "North zone",
  south: "South zone",
  west: "West zone",
  east: "East zone",
  central: "Central zone",
  all: "All",
};

export const SubsidyStatus = {
  claim_submtted: "Claim submitted",
  subsidy_credited: "Subsidy Credited",
  regitration_done: "Registration done",
  site_photo_uploaded: "Site photos and invoice uploaded",
  facilitation_paid: "facilitation charges paid to bses",
  registered_on_portal: "Registered on GNCTD portal",
};

export const SaleType = {
  free_of_cost: "Free of cost",
  sale: "Sale",
};
export const QcStatus = {
  pending: "Pending",
  rejected: "Rejected",
  completed: "Completed",
};

export const attachement_belong = {
  order: "order",
  complaint: "complaint",
  task: "task",
};

export const Ops_task_status = {
  pending: "Pending",
  under_progress: "Under Progress",
  completed: "Completed",
  cancelled: "Cancelled",
};
export const file_dir: { [key: string]: string } = {
  order: "order_attachments",
  complaint: "complaint_attachments",
  task: "task_attachments",
  pocuremnt_attachments: "procurement_attachments",
  party_attachments: "party_attachments",
  gst_attachments: "gst_attachments",
  customer_attachments: "customer_attachments",
};

export const complaintLogs = {
  created: "created",
  updated: "updated",
  pending: "pending",
  under_progress: "under progress",
  noted_for_future: "noted for future",
  solved: "solved",
  commented: "commented",
  replacement_request_raised: "replacement request raised",
  replacement_request_approved: "replacement request approved",
  replacement_request_rejected: "replacement request rejected",
  replacement_st_submitted: "replacement st submitted",
  replacement_st_hw_approved: "replacement st hw approved",
  replacement_st_hw_rejected: "replacement st hw rejected",
  replacement_st_biz_approved: "replacement st biz approved",
  replacement_st_biz_rejected: "replacement st biz rejected",
  reverse_dc_created: "reverse dc created",
  reverse_dc_creation_failed: "reverse dc creation failed",
};

export const inventoryLogs = {
  created: "created",
  updated: "updated",
  deleted: "deleted",
  installed: "installed",
  delivered: "delivered",
  returned: "returned",
  missing: "missiing",
  defect: "defect",
  commented: "commented",
  complaint: "complaint",
  org_changed: "org changed",
};

export const academyVideoCategory = {
  General: "General",
  Cms: "Cms",
  Podcasts: "Podcasts",
  Tally: "Tally",
  Sales: "Sales",
  Company_Updates: "Company Updates",
  HR_Policies: "HR Policies ",
  Life_at_kazam: "Life at Kazam",
  Startup_gyaan: "Startup gyaan",
  Ev_news: "Electric Vehicle News",
  Ev_reviews: "Electric Vehicle Reviews",
  Success_story: "Success story",
  host_driver_review: "Host and Driver Review",
};
export const OrderLogType = {
  created: "created",
  updated: "updated",
  order_approved: "order approved",
  warehouse_assigned: "warehouse assigned",
  outward_tracking_pending: "outward tracking pending",
  outward_dispatched: "outward dispatched",
  order_attachment_added: "order attachment added",

  customer_update: "customer update",
  address_update: "address update",
  added_invoice: "added invoice",
  cust_mail: "cust mail",
  item_update: "item update",
  item_added: "item added",
  item_deleted: "item deleted",
  discount_update: "discount update",
  discount_added: "discount added",
  discount_deleted: "discount deleted",
  extra_update: "extra update",
  extra_added: "extra added",
  extra_deleted: "extra deleted",
  payment_added: "payment added",
  payment_updated: "payment updated",
  payment_deleted: "payment deleted",
  payment_approved: "payment approved",
  payment_rejected: "payment rejected",
  payment_pending: "payment pending",
  payment_attachment_added: "payment attachment added",
  alloted_device_delivered: "alloted device delivered",
  alloted_device_installed: "alloted device installed",
  alloted_device_returned: "alloted device returned",
  created_task: "created task",
  created_complaint: "created complaint",
  commented: "commented",
  comment_deleted: "comment deleted",
  raw_material_update: "raw material update",
  alloted_device_deleted: "alloted device deleted",
  device_org_changed: "device org changed",
  subscription_plan_created: "subscription plan created",
  subscription_plan_updated: "subscription plan updated",
  subscription_bill_created: "subscription bill created",
};

export const TaskType = {
  instalation: "Installation",
  delivery: "Delivery",
  service: "Service",
  configuration: "Configuration",
  complaint: "Complaint",
  survey: "Survey",
  scout: "Scout",
  uninstallation: "Uninstallation",
  other: "Other",
};

export const TransferLogStatus = {
  created: "created",
  updated: "updated",
  rejected: "rejected",
  inward: "inward",
  field_updated: "field updated",
  project_changed: "project changed",
  pr_raised: "pr raised",
  item_update: "item update",
  item_added: "item added",
  item_deleted: "item deleted",
  user_added: "user added",
  receiver_added: "receiver added",
  receiver_updated: "receiver updated",
  tax_added: "tax added",
  tax_updated: "tax updated",
  level1_approval: "level1 approval",
  level2_approval: "level2 approval",
  level3_approval: "level3 approval",
  attachment_deleted: "attachment deleted",
  attachment_added: "attachment added",
  deleted: "deleted",
  draft_saved: "draft saved",
  bulk_created: "bulk created",
  revision_created: "revision created",
  tyno_export: "tyno export",
  po_close: "PO Closed",
};

export const enum MasterItemStatus {
  SavedDraft = "Saved Draft",
  PendingForApproval = "Pending for Approval",
  Approved = "Approved",
  Rejected = "Rejected",
  UpdatePending = "Update Pending",
}

export const MasterItemStatusDict = {
  SavedDraft: "Saved Draft",
  PendingForApproval: "Pending for Approval",
  Approved: "Approved",
  Rejected: "Rejected",
  UpdatePending: "Update Pending",
};

export const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Jammu and Kashmir",
  "Lakshadweep",
  "Delhi",
  "Puducherry (Pondicherry)",
];

export const ComplaintsRelatedToWithSubCategory: { [key: string]: string[] } = {
  "Device Hardware": [
    "Damaged device",
    "Device & Converter Issue",
    "MCB Tripping",
    "No Power Output from Device",
    "RCCB tripping",
    "Socket Broken",
    "Socket burnt",
    "Slow charging",
    "SPD Blown",
    "Vehicle not charging(power in the device)",
    "Faulty charging indicators",
    "Device Burnt",
    "Emergency button issue",
    "Device over heating",
    "Earthing issue",
    "RCD Fault",
    // Added from ERP Categories sheet
    "Socket Broken / Burnt",
    "No Power Output",
    "Slow Charging",
    "RCCB / RCD Fault",
    "SPD Issue",
    "PCB Burnt",
    "Relay Malfunctioning",
    "LED Malfunctioning",
    "Push Button Malfunction",
    "MCU / Microcontroller Issue",
    "SMPS Faulty",
    "Emergency Button Issue",
    "Faulty Charging Indicators",
    "Device Overheating",
    "Device and Converter Issue",
    "Vehicle not charging (power in device)",
  ],
  "Electrical / Infrastructure": [
    "Earth Fault Issue",
    "Under Voltage / Over Voltage",
    "Surge Issue",
    "PN Reversal",
    "Loose Connection in DB",
    "MCB Tripping (Infrastructure)",
    "BLE Disabled",
    "Fire Accident at Site",
    "Wire Loose Connection in Device",
  ],
  "Safety Issue": [
    "Electric Shock",
    "Sparks Observed",
    "Burning Smell",
    "PCB Burnt (Safety)",
  ],
  "Installation Issue": [
    "Earth Pit Issue",
    "Loose Connection in Wiring",
    "Unsafe Installation",
    "Fitment Issue (Wall / Pole)",
    "Delay in Installation",
  ],
  "Software / Firmware": [
    "OTA Update Issue",
    "Configuration Mismatch",
    "Wrong Firmware Version",
    "Software Fault / Bug",
    "Production Firmware Missing",
  ],
  "Delivery / Installation": ["Delivery Tracking", "Installation Scheduling"],
  "Mobile App": [
    "Bluetooth connection failed",
    "Api Integration",
    "OTP not generated (after transaction completes )",
    "OTP not generated (during login)",
    "Error during charging",
    "Maintenance Visit",
    "Socket Replacement",
    "Free Device Relocation",
  ],
  UBC: ["Support Request"],
  Enquiry: [
    "Sales Enquiry",
    "How to use App?",
    "How to Recharge?",
    "How to find Chargers?",
    "Ticket Status Followup",
    "Job Opening Enquiry",
    "General Enquiry",
  ],
  "Configuration Issues": [
    "Charging interruptions(auto cut-off)",
    "Change org",
    "Enable or disable earth",
    "Configuration pending",
  ],
  "Payment Related Issues": [
    "Discrepancy in transaction",
    "Failed wallet recharge",
    "Host Payment pending(Not Credited to host account)",
    "Invoicing Account",
    "Refund",
    "Payment failure",
    "Payment withdrawal",
    "Low wallet Balance",
  ],
  CMS: [
    "Chargers",
    "Sessions",
    "Revenue Management",
    "Charger Maintenance",
    "Reports",
    "Drivers",
  ],
  "Delivery/Installation": [
    "Earthing isuue",
    "Electricity Issues(From supplier)",
    "Faulty Wiring & Connector",
    "Incorrect installation",
    "Voltage Issue",
    "Wiring problems",
    "Vehicle Burnt",
  ],
  "Network Issue": ["Device offline"],
  Multiverse: [],
  "Device Firmware": [
    "Firmware Updation",
    "Bluetooth Not Connecting",
    "Time And Usage Not Correct",
    "Device is Offline",
  ],
  "Delivery and Installtion": ["New Installation"],
};

export const ComplaintsRelatedToWithSubCategory_HPCL: {
  [key: string]: string[];
} = {
  "Device Hardware": [
    "Connector Unavailable",
    "Gun Lock Issue",
    "Charger Not Powering On",
    "Charger Offline",
    "Display / Touchscreen Not Working",
    "Emergency Stop Pressed",
    "Not Resetting",
    "Overheating",
    "Power Supply Issue / Voltage Fluctuation",
    "Slow Charging Speed",
    "Cable Damage",
    "BMS Communication Error",
    "SIM Network Fault",
    "Vehicle Not Charging (Power In Device)",
    "SPD Burnt",
    "AC/ DC Contractor Failure",
    "RNL Faulty",
    "Router Replacement",
    "Gun Temperature Issue",
    "Faulty Wiring & Connector",
  ],
  CMS: [
    "Session Data Not Synced",
    "Charger Not Visible / Mapped Incorrectly",
    "Data Mismatch (Kwh / Duration / Cost)",
    "Reporting",
    "Dashboard Inaccuracy",
    "Stop Sessions",
    "Charger Not Sending Heartbeat",
    "Charging Interruptions(Auto Cut-Off)",
    "Host Details Incorrect",
  ],
  "Payment Related Issues": [
    "Hp Reload Limit Exceeded",
    "Refund Pending",
    "Payment Failure",
    "Wallet Recharge",
    "User Registration",
    "Balance Not Updated",
    "Upi Option Not Showing",
    "Hp E Charge Transaction Initiation Failed",
    "Usb Debugging Unabled In Device",
    "Balance Not Synced",
    "Discrepancy In Transaction",
    "Host Payment Pending(Not Credited To Host Account)",
  ],
  "Mobile App": [
    "Otp Issues",
    "User Does Not Exist",
    "Something Went Wrong",
    "Loading Delay",
    "Session Not Starting",
    "App Freeze During Charging",
    "Session History Not Visible",
    "Invoice Not Visible",
    "Profile Update Issue",
    "Coupon",
    "Offer Not Applied",
    "Feedback",
    "Rating Not Captured",
    "Sap Code Not Found",
    "Charger Availability Mismatch",
    "Mobile Number Not Registered",
    "Transfer Initiation Failed",
    "Hp Pay Mobile Number Not Registered",
    "Hp Pay Hotlisted Customer",
    "Hp Pay Payment Mode Not Found",
    "Hp Pay Customer Not Found",
    "Hp Pay App Running In Emulator",
    "Hp E Charge Concent Note",
  ],
  Enquiry: [
    "No Response From User",
    "How To Use App?",
    "How To Recharge?",
    "How To Find Nearby Chargers?",
    "Follow Up Call",
    "Steps To Charge Vehicle",
    "Rfid Inquiry",
  ],
};

export const IncidentStatus = {
  Open: "Open",
  Resolved: "Resolved",
  Escalated: "Escalated",
};
